import * as Yup from 'yup';

export const schema = Yup.object().shape({
    email: Yup.string()
        .trim()
        .matches(/@stone.com.br$/, 'Necessário ser email stone')
        .required('Campo obrigatório')
    ,
    pessoaResponsavel: Yup.string()
        .nullable()
        .typeError('Campo obrigatório')
        .required('Campo obrigatório')
    ,
    contato: Yup.string()
        .required('Campo obrigatório')
    ,
    cep: Yup.string()
        .trim()
        .min(8, 'O cep deve ter 8 dígitos')
        .max(9, 'O cep deve ter 8 dígitos')
        .required('Informe o seu código postal no formato: 20221-310')
    ,
    endereco: Yup.string()
        .required('Campo obrigatório'),
    numeroEndereco: Yup.string()
        .required('Campo obrigatório'),
    complemento: Yup.string()
    ,
    bairro: Yup.string()
        .required('Campo obrigatório')
    ,
    cidade: Yup.string()
        .min(2, "O campo estado deve uma cidade valida ex: Rio de janeiro")
        .required('Campo obrigatório')
    ,
    uf: Yup.string()
        .required('Campo obrigatório')
    ,
    latitude: Yup.string()
        .required('Campo obrigatório'),
    longitude: Yup.string()
        .required('Campo obrigatório'),
});